import { ReactElement } from 'react';
import {
  TabbedFormViewProps,
  TabbedForm,
  TextInput,
  maxLength,
  PasswordInput,
  minLength,
} from 'react-admin';

export default function MerchantConfigTab(props: TabbedFormViewProps): ReactElement {
  return (
    <TabbedForm.Tab label="Registration User Config" {...props}>
      <TextInput label="Type" source="attributes.type" validate={maxLength(255)} />
      <TextInput label="Username" source="attributes.username" validate={[maxLength(50)]} />
      <PasswordInput
        label="Password"
        placeholder="**********"
        source="attributes.password"
        validate={minLength(8)}
      />
      <TextInput label="Feed" source="attributes.feed" validate={maxLength(255)} />
    </TabbedForm.Tab>
  );
}
